module.exports = __webpack_public_path__ + "img/about-us.58a74e5d.png";